import styled from 'styled-components';

import Link from './Link';

const primaryColor = '#6048F3';
const StyledButton = styled('button')`
  background-color: ${primaryColor};
  background-image: linear-gradient(34deg, #d93ae0, #6048f3);
  cursor: pointer;
  border-radius: 4px;
  border: none;
  color: #ffffff;
  font-size: small;
  margin-right: 10px;
  margin: 0;
  min-width: initial;
  padding: 12px 30px;
  transition: all 0.2s ease-in-out;
  &:hover,
  &:focus,
  &:active {
    background-image: linear-gradient(230deg, #a148d6 30%, #5d50d1 100%);
    background-color: ${primaryColor};
    transform: scale(1.1);
  }
`;

type RedirectButtonProps = {
  url: string;
  text: string;
};

function RedirectButton({ url, text }: RedirectButtonProps) {
  return (
    <Link href={url} target="_blank">
      <StyledButton>{text}</StyledButton>
    </Link>
  );
}

export default RedirectButton;
